import EventEmitter from 'eventemitter3'
import messages from './messages.json'

export default new (class IntlService extends EventEmitter {
  constructor() {
    super()
    this.defaultLocale = 'de-DE'
    this.locale = this.defaultLocale
    this.messages = messages
  }

  setLocale(locale) {
    if (this.locale === locale) return
    this.locale = locale
    this.emit('localeChanged', locale)
  }

  get(key) {
    const messages = this.messages[this.locale]
    return messages && messages[key]
  }
})()
